import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { IconRegularChevronRight } from '@notino/react-styleguide';

import { ActionButton } from './components/ActionButton';
import { Description } from './components/Description';
import { Images } from './components/Images';
import { Title } from './components/Title';
import { useSkinAnalyzerVisibility } from './hooks/useAnalyzerVisibility';
import { useBrand } from './hooks/useBrand';
import { useInitSkinAnalyzer } from './lib/hooks/useInitSkinAnalyzer';
import { openSkinAnalyzer } from './lib/skinAnalyzerScripts';
import { trackViewOrSelectPromotion } from './lib/tracking';
import { DescriptionAndActionWrapper, SkinAnalyserWrapper } from './styled';

const SkinAnalyser = () => {
  const { inView, ref } = useInView({
    triggerOnce: true,
  });

  const { isEstee } = useBrand();

  const brandName = isEstee ? 'Estée Lauder' : 'La Roche-Posay';

  useInitSkinAnalyzer({
    inView,
    brand: brandName,
  });

  const { isVariant1, isVariant2 } = useSkinAnalyzerVisibility();

  const onOpenSkinAnalyzer = () => {
    trackViewOrSelectPromotion(brandName, 'select_promotion');
    openSkinAnalyzer();
  };

  return (
    <SkinAnalyserWrapper
      onClick={isVariant1 ? onOpenSkinAnalyzer : undefined}
      ref={ref}
      isVariant2={isVariant2}
    >
      <Images />

      <DescriptionAndActionWrapper isVariant2={isVariant2}>
        <Title />

        <Description />

        {isVariant2 && <ActionButton onOpenSkinAnalyzer={onOpenSkinAnalyzer} />}
      </DescriptionAndActionWrapper>

      {isVariant1 && <IconRegularChevronRight color="icon.tertiary" />}
    </SkinAnalyserWrapper>
  );
};

export default SkinAnalyser;
